module.exports = __webpack_public_path__ + "img/25.47c38791.png";